import * as React from "react";
import {useState} from "react";
import {TextField, Button, Snackbar} from "web-com";
import {FIELD_NAMES} from "profile/enums";
import {regex} from "profile/regex";
import {INPUT_TYPE} from "utils/variables";
import {saveOpportunityProfile} from "consent/api";
import {partnerOfferings} from "login/config";
import {IProfile} from "profile/interface";
import "./styles.scss";

interface IAlternateMobileNumber {
  oppId: string;
  onComplete: () => void;
  utm_source?: string;
}

const sectionMsg = {
  beforeClick: "Please add a mobile number of your family or a friend who is reachable by you.\nA verification link will be sent to this number to click and proceed further.",
  afterClick: "Please check the verification link sent to your mobile by SMS",
};
const invalidNumberMsg = "Please enter a valid number";

const AlternateMobileNumber = (props: IAlternateMobileNumber) => {
  const [alternateNumber, setAlternateNumber] = useState<string | null>(null);
  const [refName, setRefName] = useState<string>();
  const [isLinkSent, setIsLinkSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const validateNumber = (): boolean => {
    const mobileRegExp = new RegExp(regex[FIELD_NAMES.REFERENCE_MOBILE]);
    return mobileRegExp.test(alternateNumber);
  };

  const handleSendLink = async () => {
    if (!validateNumber()) {
      setError(invalidNumberMsg);
      return;
    }
    try {
      props.oppId && await saveOpportunityProfile(
        props.oppId, 
        {references: [{
            referenceMobile: alternateNumber,
            referenceName: refName
          }]
        } as IProfile
      );
      setIsLinkSent(true);
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong! Try Again.");
    }
  };

  const handleNumberChange = (_, value: string) => {
    setError(null);
    setAlternateNumber(value);
  };

  const handleRefNameChange = (_, value: string) => {
    setError(null);
    setRefName(value);
  };

  const disableSendLink = !(alternateNumber && refName) || alternateNumber.length < 10 || isLinkSent;

  return (
    <div className="alternate-mobile-number-container flex-column-center-row">
      <TextField
        type={INPUT_TYPE.TEXT}
        placeholder="Enter reference name"
        value={refName}
        fieldName="refName"
        onChange={handleRefNameChange}
        label="Reference Name"
      />
      <TextField
        type={INPUT_TYPE.NUMBER}
        placeholder="Enter reference mobile number"
        value={alternateNumber}
        fieldName="alternateMobileNumber"
        onChange={handleNumberChange}
        errorMsg={error}
        label="Reference Mobile Number"
        max="10"
      />
      <Button
        bgColor={partnerOfferings[props.utm_source]?.colors?.green}
        buttonText="Send Link"
        isDisabled={disableSendLink}
        onClick={handleSendLink}
        rounded={true}
      />
      <div className="section-msg flex-center">
        {!isLinkSent && sectionMsg.beforeClick}
      </div>
      <Snackbar
        type="SUCCESS"
        timeout={3000}
        show={isLinkSent}
        onCloseHandler={() => props.onComplete()}
      >
        {sectionMsg.afterClick}
      </Snackbar>
    </div>
  );
};

export default AlternateMobileNumber;
